
import { Component, Prop, PropSync } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { DateFormatMixin, HeMixin } from "@/mixins";
import { CDataTableFields } from "@/@types";

@Component({
  components: {},
})
export class TechAppUsersList extends mixins(DateFormatMixin, HeMixin) {
  @Prop({ default: () => [] })
  private items!: any[];

  @Prop({ default: () => false })
  private loading!: boolean;

  @Prop({ default: () => false })
  private actionLoading!: boolean;

  @Prop({ default: () => 0 })
  private total!: boolean;

  @Prop({ default: () => true })
  private itemsPerPageSelect!: boolean;

  @PropSync("itemsPerPage", { default: () => 25, type: Number })
  itemsPerPageSync!: number;

  @PropSync("columnFilterValue", { default: () => ({}), type: Object })
  columnFilterValueSync!: any;

  @PropSync("sorterValue", { default: () => ({}), type: Object })
  sorterValueSync!: { column: string | null; asc: string | boolean };

  page = 1;

  fields: CDataTableFields = [
    { key: "firstname", label: "First Name" },
    { key: "lastname", label: "Last Name" },
    { key: "cognito_email", label: "Login Email" },
    // { key: "enabled", label: "Enabled" },
    // { key: "status", label: "Status" },
  ];

  getEnabledColor(enabled: boolean | null): string {
    if (enabled === true) {
      return "success";
    } else if (enabled === false) {
      return "danger";
    } else {
      return "secondary";
    }
  }

  getEnabledText(enabled: boolean | null): string {
    if (enabled === true) {
      return "Yes";
    } else if (enabled === false) {
      return "No";
    } else {
      return "Unknown";
    }
  }

  getStatusColor(status: string | null): string {
    if (!status) return "secondary";
    
    switch (status.toLowerCase()) {
      case "confirmed":
        return "success";
      case "unconfirmed":
        return "warning";
      case "force_change_password":
        return "info";
      case "reset_required":
        return "warning";
      case "admin_create_user":
        return "info";
      default:
        return "secondary";
    }
  }

  onTotalPageChange(val: number) {
    this.itemsPerPageSync = val;
    this.$emit('items-per-page-change', val);
  }

  onColumnFilterChange(val: any) {
    this.columnFilterValueSync = val;
    this.$emit('filter-change', val);
  }

  onSorterValueChange(val: { column: string; asc: boolean }) {
    this.sorterValueSync = val;
    this.$emit('sorter-change', val);
  }

  async handleEnabledClick(item: any) {
    // Don't perform any action if status is unknown (null)
    if (item.enabled === null) {
      return;
    }

    const isCurrentlyEnabled = item.enabled === true;
    const action = isCurrentlyEnabled ? 'disable' : 'enable';
    const actionText = isCurrentlyEnabled ? 'disable access' : 'enable access';
    
    const confirmed = await this.showConfirmationDialog(
      `Are you sure you want to ${actionText} of this user?`,
      `Yes, ${action} access`,
      'Cancel'
    );

    if (confirmed) {
      this.$emit('toggle-user-access', {
        cognito_email: item.cognito_email,
        action: action
      });
    }
  }

  private showConfirmationDialog(message: string, confirmText: string, cancelText: string): Promise<boolean> {
    return new Promise((resolve) => {
      // Using browser's native confirm dialog for simplicity
      // In a production app, you might want to use a custom modal component
      const result = confirm(message);
      resolve(result);
    });
  }

  async handleEditEmail(item: any) {
    this.$emit('edit-user-email', {
      cognito_email: item.cognito_email,
      emp_id: item.emp_id
    });
  }
}

export default TechAppUsersList;
